import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  StepContent,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import { DatePicker } from "material-ui-pickers";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from "moment";
import "moment/locale/pt-br";
import React, { Component } from "react";
import { colors } from "../../../styles";
import PassengersModal from "../../../routes/settings/passengers/Modal.js";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { connect } from "react-redux";
import { navigate } from "../../../actions/routerResolve";
import { msgSimple } from "../../../actions/snackbarActions";
import MultiSelect from "../../../components/MultiSelect";
import ProviderService from "../../../tools/ProviderService";
import UserService from "../../../tools/UserService";
import withReactContent from "sweetalert2-react-content";
import { constants } from "../../../config";

//SweetAlert
import Swal from "sweetalert2";
//Fix the css
import {
  MissionStatusAuthorized,
  MissionStatusNotAuthorized,
  PROFILE_STATUS,
  StatusToConfirm,
  allowAccessToMissionRequestAdmin,
} from "../../../enums";
import PassengerService from "../../../tools/PassengerService";
import "../style.css";

const MySwal = withReactContent(Swal);

class ModalMission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "new",
      open: false,
      loading: false,
      openPax: false,
      modalPax: { id: "new" },
      newPax: "",
      modal: {
        from: "",
        to: "",
        status: "Solicitado",
        date: new Date(),
        local_time: null,
        fuso_information: null,
        passengers_summary: "",
        observations: "",
        logbook_number: "",
        alternate_destination: "",
        departure_date: null,
        presentation_time: null,
        hangar_time_departure: null,
        takeoff_time: null,
        arrival_date: null,
        takeoff_time_utc: null,
        arrival_time: null,
        arrival_time_utc: null,
        flight_time: "",
        fuel: "",
        load: "",
        speed: "",
        origin: "",
        destination: "",
        obs_origin: "",
        obs_steward: "",
        obs_destination: "",
        obs_destination_alt: "",
        obs_passenger: "",
        obs_aircrew: "",
        obs_maintenance: "",
        qty_pax: "",
        passengers: [],
        coord_pilots: [],
        second_pilots: [],
        reserve_pilots: [],
        mechanics: [],
        auxiliarys: [],
        catering: "",
        stewardess: [],
        stewardess_reserve: [],
        supplier_origin: [],
        supplier_origin_service: [],
        supplier_fuel: [],
        supplier_destination: [],
        supplier_destination_service: [],
        supplier_hotel: [],
        supplier_stewarde: [],
      },
      activeStep: 0,
      status: [
        "Solicitado",
        "Programado",
        "Confirmado",
        "Alterado",
        "EmAndamento",
        "Finalizado",
        "Cancelado",
        "Suspenso",
      ],
      users: [],
      pilots: [],
      coord_pilots: [],
      second_pilots: [],
      reserve_pilots: [],
      stewardess: [],
      stewardess_reserve: [],
      stewardess_default: [],
      suppliers_origin: [],
      suppliers_origin_service: [],
      suppliers_fuel: [],
      suppliers_destination: [],
      suppliers_destination_service: [],
      suppliers_hotel: [],
      suppliers_stewarde: [],
      maintenance: [],
      mechanics: [],
      auxiliarys: [],
      role: JSON.parse(localStorage.getItem(constants.userKey)).user.profile,
    };
    this.profile = this.props.user.user.profile;
  }

  componentWillMount() {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.docs.map((element) => ({
            value: element.id,
            label: `${element.first_name} ${element.last_name}`,
          }));
          this.setState({
            users: suggestions,
          });
        }
      }
    );

    UserService.get(null, null, true, null, true, "Piloto").then(
      async (result) => {
        if (result.ok) {
          let suggestions_pilots = await result.response.map((element) => ({
            value: element.id,
            label: element.first_name + " " + element.last_name,
          }));
          this.setState({
            pilots: suggestions_pilots,
            coord_pilots: suggestions_pilots,
            second_pilots: suggestions_pilots,
            reserve_pilots: suggestions_pilots,
          });
        }
      }
    );

    UserService.get(null, null, true, null, true, "Comissária").then(
      async (result) => {
        if (result.ok) {
          let suggestions_stewardess = await result.response.map((element) => ({
            value: element.id,
            label: element.first_name + " " + element.last_name,
          }));
          this.setState({
            stewardess: suggestions_stewardess,
            stewardess_default: suggestions_stewardess,
            stewardess_reserve: suggestions_stewardess,
          });
        }
      }
    );

    UserService.get(null, null, true, null, true, "Manutenção").then(
      async (result) => {
        if (result.ok) {
          let suggestions_maintenance = await result.response.map(
            (element) => ({
              value: element.id,
              label: element.first_name + " " + element.last_name,
            })
          );
          this.setState({
            maintenance: suggestions_maintenance,
            mechanics: suggestions_maintenance,
            auxiliarys: suggestions_maintenance,
          });
        }
      }
    );

    ProviderService.get(null, null, true, null, true).then(async (result) => {
      if (result.ok) {
        let clear = [];

        await result.response.map(async (element) => {
          let be = false;
          await element.supplier_types.map((item) => {
            if (item.name === "Atendimento" || item.name === "Combustíveis")
              be = true;
          });
          if (!be) clear.push(element);
        });

        let suggestions = await clear.map((element) => {
          return {
            value: element.id,
            label: element.name + " - " + element.base,
          };
        });

        this.setState({
          suppliers_origin: suggestions,
          suppliers_destination: suggestions,
        });
      }
    });

    ProviderService.get(null, null, true, null, true, "Atendimento").then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.map((element) => ({
            value: element.id,
            label: element.name + " - " + element.base,
          }));
          this.setState({
            suppliers_origin_service: suggestions,
            suppliers_destination_service: suggestions,
          });
        }
      }
    );

    ProviderService.get(null, null, true, null, true, "Combustíveis").then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.map((element) => ({
            value: element.id,
            label: element.name + " - " + element.base,
          }));
          this.setState({
            suppliers_fuel: suggestions,
          });
        }
      }
    );

    ProviderService.get(null, null, true, null, true, "Hotel").then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.map((element) => ({
            value: element.id,
            label: element.name + " - " + element.base,
          }));
          this.setState({
            suppliers_hotel: suggestions,
          });
        }
      }
    );

    ProviderService.get(null, null, true, null, true, "Comissaria").then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.map((element) => ({
            value: element.id,
            label: element.name + " - " + element.base,
          }));
          this.setState({
            suppliers_stewarde: suggestions,
          });
        }
      }
    );
  }

  getSteps = () => {
    return ["Select campaign settings", "Create an ad group", "Create an ad"];
  };

  handleRefreshState = async () => {
    PassengerService.getPassenger(null, 999999, 1, null, null, null).then(
      async (result) => {
        if (result.ok) {
          let suggestions = await result.response.docs.map((element) => ({
            value: element.id,
            label: `${element.first_name} ${element.last_name}`,
          }));
          this.setState({
            users: suggestions,
          });
        }
      }
    );
  };

  openPaxDialog = (value) => {
    if (value) {
      this.setState({ newPax: value });
    }
    this.setState({ openPax: !this.state.openPax });
  };

  handleClosePax = () => {
    this.setState({ openPax: !this.state.openPax });
  };

  handleSavePax = (item) => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then((result) => {
      console.log(item);
      if (!!result.value) {
        //Save user
        if (item.id === "new") {
          let { users } = this.state;
          users.push({ ...item });
          users.reverse();
          this.setState({ users });
          this.setState({ loading: true });
          delete item.id;
          PassengerService.create(item).then((result) => {
            if (result.ok) {
              this.handleRefreshState();
              this.props.msgSimple(
                item.first_name + " " + item.last_name + " criado com sucesso."
              );
            } else {
              let { users } = this.state;
              users = users.filter((e) => e.id !== "new");
              users.reverse();
              this.setState({ users });
              this.props.msgAction(
                'Erro ao criar "' +
                  item.first_name +
                  " " +
                  item.last_name +
                  '"',
                "TENTAR NOVAMENTE",
                () => this.handleSave(item)
              );
            }
          });
        }
        this.setState({ openPax: false, loading: false });
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  excludeElement = (element) => {
    console.log(element);
  };

  autoComplete = async (name, type) => {
    // console.log(name)

    let {
      suppliers_origin_service,
      suppliers_origin,
      suppliers_destination_service,
      suppliers_destination,
      suppliers_fuel,
      suppliers_hotel,
      suppliers_stewarde,
    } = this.state;

    let { modal } = this.state;
    if (type === "destination") {
      if (name) {
        suppliers_destination_service =
          await suppliers_destination_service.filter((el) => {
            if (el.label.indexOf(name) !== -1) return el;
          });
        suppliers_destination = await suppliers_destination.filter((el) => {
          if (el.label.indexOf(name) !== -1) return el;
        });
        suppliers_hotel = await suppliers_hotel.filter((el) => {
          if (el.label.indexOf(name) !== -1) return el;
        });

        await this.setState({
          modal: {
            ...modal,
            supplier_destination_service: suppliers_destination_service,
            supplier_destination: suppliers_destination,
            supplier_hotel: suppliers_hotel,
            destination: name,
          },
        });
      } else {
        await this.setState({
          modal: {
            ...modal,
            supplier_destination_service: [],
            supplier_destination: [],
            supplier_hotel: [],
            destination: name,
          },
        });
      }
    } else if (type === "origin") {
      if (name) {
        suppliers_origin_service = await suppliers_origin_service.filter(
          (el) => {
            if (el.label.indexOf(name) !== -1) return el;
          }
        );
        suppliers_origin = await suppliers_origin.filter((el) => {
          if (el.label.indexOf(name) !== -1) return el;
        });
        suppliers_fuel = await suppliers_fuel.filter((el) => {
          if (el.label.indexOf(name) !== -1) return el;
        });
        suppliers_stewarde = suppliers_stewarde.filter((el) => {
          if (el.label.indexOf(name) !== -1) return el;
        });

        await this.setState({
          modal: {
            ...modal,
            supplier_origin_service: suppliers_origin_service,
            supplier_origin: suppliers_origin,
            supplier_fuel: suppliers_fuel,
            supplier_stewarde: suppliers_stewarde,
            origin: name,
          },
        });
      } else {
        await this.setState({
          modal: {
            ...modal,
            supplier_origin_service: [],
            supplier_origin: [],
            supplier_fuel: [],
            supplier_stewarde: [],
            origin: name,
          },
        });
      }
    }
  };

  getStepContent = (step) => {
    console.log(this.profile);
    if (this.profile === PROFILE_STATUS.SOLICITANTE) {
      step = 2;
    }
    switch (step) {
      case 0:
        return (
          <Grid container spacing={8} style={{ marginBottom: 160 }}>
            <Grid
              container
              spacing={8}
              direction="row"
              alignItems="flex-end"
              item
              md={12}
            >
              <Grid item xs={12} sm={12} md={6} lg={3}>
                <TextField
                  id="origin"
                  label="Aeródromo - ICAO"
                  style={{ width: "100%", marginTop: 4 }}
                  value={this.state.modal.origin}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        origin: event.target.value.toUpperCase(),
                      },
                    });
                    // this.autoComplete(event.target.value.toUpperCase(), 'origin')
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.supplier_origin_service}
                  suggestions={this.state.suppliers_origin_service}
                  placeholder="Selecione o atendimento"
                  label="Atendimento/FBO"
                  onChange={(value) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, supplier_origin_service: value },
                    });
                  }}
                />
              </Grid> */}
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                  locale="pt-br"
                >
                  <DatePicker
                    style={{ width: "100%", marginTop: 4 }}
                    label="Data de Decolagem"
                    disablePast
                    format="DD/MM/YYYY"
                    cancelLabel="SAIR"
                    okLabel="OK"
                    clearable
                    clearLabel="LIMPAR"
                    value={this.state.modal.departure_date}
                    onChange={(departure_date) => {
                      let { modal } = this.state;
                      this.setState({
                        modal: {
                          ...modal,
                          departure_date,
                          arrival_date: departure_date,
                        },
                      });
                    }}
                    animateYearScrolling
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <TextField
                  id="time"
                  label="Hora de Decolagem (Local)"
                  type="time"
                  // defaultValue="00:00"
                  style={{ width: "100%" }}
                  value={this.state.modal.takeoff_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, takeoff_time: event.target.value },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <TextField
                  id="time"
                  label="Tempo de Voo"
                  type="time"
                  style={{ width: "100%" }}
                  value={this.state.modal.flight_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, flight_time: event.target.value },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
              </Grid>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="time"
                label="Hora da Apresentação"
                type="time"
                // defaultValue="00:00"
                style={{ width: '100%' }}
                value={this.state.modal.presentation_time}
                onChange={event => {
                  let { modal } = this.state;
                  this.setState({ modal: { ...modal, presentation_time: event.target.value } })
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="time"
                label="Hora de Saída do Hangar"
                type="time"
                // defaultValue="00:00"
                style={{ width: '100%' }}
                value={this.state.modal.hangar_time_departure}
                onChange={event => {
                  let { modal } = this.state;
                  this.setState({ modal: { ...modal, hangar_time_departure: event.target.value } })
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="time"
                label="Hora de Decolagem (UTC)"
                type="time"
                style={{ width: "100%" }}
                value={this.state.modal.takeoff_time_utc}
                onChange={(event) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, takeoff_time_utc: event.target.value },
                  });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="load"
                label="Carga / Unidade"
                style={{ width: "100%" }}
                value={this.state.modal.load}
                onChange={(event) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, load: event.target.value },
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="speed"
                label="Velocidade / Unidade"
                style={{ width: "100%" }}
                value={this.state.modal.speed}
                onChange={(event) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, speed: event.target.value },
                  });
                }}
              />
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="fuel"
                label="Combustível dec / Unidade"
                style={{ width: "100%" }}
                value={this.state.modal.fuel}
                onChange={(event) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, fuel: event.target.value },
                  });
                }}
              />
            </Grid> */}
            <Grid></Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}> */}
            {/* <TextField
                                id="fuel"
                                label="Fornecedor de Combustível"
                                style={{ width: '100%' }}
                                value={this.state.modal.supplier_fuel}
                                onChange={event => {
                                    let { modal } = this.state;
                                    this.setState({ modal: { ...modal, supplier_fuel: event.target.value } })
                                }}

                            /> */}
            {/* <MultiSelect
                isPax={{
                  isPax: false,
                  openPaxDialog: this.openPaxDialog,
                }}
                value={this.state.modal.supplier_fuel}
                suggestions={this.state.suppliers_fuel}
                placeholder="Selecione o fornecedor"
                label="Fornecedor de Combustível"
                onChange={(value) => {
                  let { modal } = this.state;
                  this.setState({ modal: { ...modal, supplier_fuel: value } });
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <MultiSelect
                isPax={{
                  isPax: false,
                  openPaxDialog: this.openPaxDialog,
                }}
                value={this.state.modal.supplier_origin}
                suggestions={this.state.suppliers_origin}
                placeholder="Selecione os fornecedores"
                label="Demais Fornecedores"
                onChange={(value) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, supplier_origin: value },
                  });
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                onClick={() => {
                  this.props.handleSave({ ...this.state.modal });
                }}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
              <Button onClick={this.handleCloseStep} color="secondary">
                Cancelar
              </Button>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                label="Observações"
                                style={{ width: '100%' }}
                                value={this.state.modal.obs_origin}
                                onChange={event => {
                                    let { modal } = this.state;
                                    this.setState({ modal: { ...modal, obs_origin: event.target.value } })
                                }}

                            />
                        </Grid> */}
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={8} style={{ marginBottom: 160 }}>
            <Grid
              container
              direction="row"
              alignItems="flex-end"
              spacing={8}
              item
              md={12}
            >
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  id="destination"
                  label="Aeródromo - ICAO"
                  style={{ width: "100%" }}
                  value={this.state.modal.destination}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        destination: event.target.value.toUpperCase(),
                      },
                    });
                    // this.autoComplete(event.target.value.toUpperCase(), 'destination')
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                                disabled
                                id="fuel"
                                label="Atendimento"
                                style={{ width: '100%' }}
                                value={''}
                                onChange={event => {
                                    let { modal } = this.state;
                                    this.setState({ modal: { ...modal, fuel: event.target.value } })
                                }}

                            />
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.supplier_destination_service}
                  suggestions={this.state.suppliers_destination_service}
                  placeholder="Selecione o atendimento"
                  label="Atendimento"
                  onChange={(value) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, supplier_destination_service: value },
                    });
                  }}
                />
              </Grid> */}
              <Grid item xs={12} sm={12} md={3}>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                  locale="pt-br"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    label="Data de Chegada"
                    format="DD/MM/YYYY"
                    cancelLabel="SAIR"
                    okLabel="OK"
                    minDate={this.state.modal.departure_date}
                    value={this.state.modal.arrival_date}
                    onChange={(arrival_date) => {
                      let { modal } = this.state;
                      this.setState({ modal: { ...modal, arrival_date } });
                    }}
                    animateYearScrolling
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <TextField
                  id="time"
                  label="Hora de Chegada (Local)"
                  type="time"
                  // defaultValue="00:00"
                  style={{ width: "100%" }}
                  value={this.state.modal.arrival_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, arrival_time: event.target.value },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
              </Grid>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                            <MuiPickersUtilsProvider
                                utils={MomentUtils}
                                moment={moment}
                                locale='pt-br'
                            >
                                <DatePicker
                                    style={{ width: '100%' }}
                                    label="Data de Saída"
                                    format='DD/MM/YYYY'
                                    cancelLabel='SAIR'
                                    okLabel='OK'
                                    clearable
                                    clearLabel='LIMPAR'
                                    value={this.state.modal.departure_date}
                                    onChange={departure_date => {
                                        let { modal } = this.state;
                                        this.setState({ modal: { ...modal, departure_date } })
                                    }}
                                    animateYearScrolling
                                />
                            </MuiPickersUtilsProvider>
                        </Grid> */}

            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField
                id="time"
                label="Hora de Chegada (UTC)"
                type="time"
                // defaultValue="00:00"
                style={{ width: "100%" }}
                value={this.state.modal.arrival_time_utc}
                onChange={(event) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, arrival_time_utc: event.target.value },
                  });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <MultiSelect
                isPax={{
                  isPax: false,
                  openPaxDialog: this.openPaxDialog,
                }}
                value={this.state.modal.supplier_hotel}
                suggestions={this.state.suppliers_hotel}
                placeholder="Selecione o hotel"
                label="Hotel da Tripulação"
                onChange={(value) => {
                  let { modal } = this.state;
                  this.setState({ modal: { ...modal, supplier_hotel: value } });
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
              <MultiSelect
                isPax={{
                  isPax: false,
                  openPaxDialog: this.openPaxDialog,
                }}
                value={this.state.modal.supplier_destination}
                suggestions={this.state.suppliers_destination}
                placeholder="Selecione o fornecedor"
                label="Demais Fornecedores"
                onChange={(value) => {
                  let { modal } = this.state;
                  this.setState({
                    modal: { ...modal, supplier_destination: value },
                  });
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                onClick={() => {
                  this.props.handleSave({ ...this.state.modal });
                }}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
              <Button onClick={this.handleCloseStep} color="secondary">
                Cancelar
              </Button>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                label="Observações"
                                style={{ width: '100%' }}
                                value={this.state.modal.obs_destination}
                                onChange={event => {
                                    let { modal } = this.state;
                                    this.setState({ modal: { ...modal, obs_destination: event.target.value } })
                                }}

                            />
                        </Grid> */}
          </Grid>
        );
      case 10:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginBottom: 20 }}
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextField
                  // id="landing_alternative"
                  label="Aeródromo - ICAO"
                  style={{ width: "100%" }}
                  value={this.state.modal.alternate_destination}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        alternate_destination: event.target.value.toUpperCase(),
                      },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <TextField
                  label="Observações"
                  style={{ width: "100%" }}
                  value={this.state.modal.obs_destination_alt}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        obs_destination_alt: event.target.value,
                      },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginBottom: 160 }}
              spacing={8}
            >
              {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  id="qty_pax"
                  label="Qty de Passageiros"
                  style={{ width: "100%", marginTop: 3 }}
                  value={this.state.modal.qty_pax}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, qty_pax: event.target.value },
                    });
                  }}
                />
              </Grid> */}
              <Grid item xs={12} sm={12} md={12}>
                <MultiSelect
                  isPax={{
                    isPax: true,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.passengers}
                  suggestions={this.state.users}
                  placeholder="Selecione os passageiros"
                  label="Passageiros"
                  onChange={(value) => {
                    let { modal } = this.state;
                    this.setState({ modal: { ...modal, passengers: value } });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    label="Observações"
                                    style={{ width: '100%' }}
                                    value={this.state.modal.obs_passenger}
                                    onChange={event => {
                                        let { modal } = this.state;
                                        this.setState({ modal: { ...modal, obs_passenger: event.target.value } })
                                    }}

                                />
                            </Grid> */}
            </Grid>
          </Grid>
        );
      case 10:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginBottom: 160 }}
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.coord_pilots}
                  suggestions={this.state.coord_pilots}
                  placeholder="Selecione os pilotos"
                  label="Piloto Coordenador"
                  onChange={(value) => {
                    let { modal, pilots } = this.state;
                    let { second_pilots, reserve_pilots } = this.state.modal;
                    // let { second_pilots, reserve_pilots } =  this.state;
                    let no = [...value, ...second_pilots, ...reserve_pilots];
                    let aux = [];
                    console.log(no);
                    let list = pilots;
                    no.map((e) => {
                      aux = list.filter((element) => element.value !== e.value);
                      list = list.filter(
                        (element) => element.value !== e.value
                      );
                    });
                    if (!no.length) aux = list;
                    console.table(aux);
                    this.setState({
                      modal: { ...modal, coord_pilots: value },
                      second_pilots: aux,
                      reserve_pilots: aux,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.second_pilots}
                  suggestions={this.state.second_pilots}
                  placeholder="Selecione os pilotos"
                  label="Demais Pilotos do Voo"
                  onChange={(value) => {
                    let { modal, pilots } = this.state;
                    let { coord_pilots, reserve_pilots } = this.state.modal;
                    // let { second_pilots, reserve_pilots } =  this.state;
                    let no = [...value, ...coord_pilots, ...reserve_pilots];
                    let aux = [];
                    console.log(no);
                    let list = pilots;
                    no.map((e) => {
                      aux = list.filter((element) => element.value !== e.value);
                      list = list.filter(
                        (element) => element.value !== e.value
                      );
                    });
                    if (!no.length) aux = list;
                    console.table(aux);
                    this.setState({
                      modal: { ...modal, second_pilots: value },
                      coord_pilots: aux,
                      reserve_pilots: aux,
                    });
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <MultiSelect
                                    isPax={{
                                        isPax: false,
                                        openPaxDialog: this.openPaxDialog
                                    }}
                                    value={this.state.modal.reserve_pilots}
                                    suggestions={this.state.reserve_pilots}
                                    placeholder='Selecione os pilotos'
                                    label='Piloto Coordenador do Voo'
                                    onChange={value => {
                                        let { modal, pilots } = this.state;
                                        let { second_pilots, coord_pilots } = this.state.modal;
                                        // let { second_pilots, reserve_pilots } =  this.state;
                                        let no = [...value, ...coord_pilots, ...second_pilots];
                                        let aux = [];
                                        console.log(no);
                                        let list = pilots;
                                        no.map(e => {
                                            aux = list.filter(element => element.value !== e.value);
                                            list = list.filter(element => element.value !== e.value);
                                        })
                                        if (!no.length)
                                            aux = list;
                                        console.table(aux);
                                        this.setState({ modal: { ...modal, reserve_pilots: value }, coord_pilots: aux, second_pilots: aux })
                                    }}
                                />
                            </Grid> */}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    label="Observações"
                                    style={{ width: '100%' }}
                                    value={this.state.modal.obs_aircrew}
                                    onChange={event => {
                                        let { modal } = this.state;
                                        this.setState({ modal: { ...modal, obs_aircrew: event.target.value } })
                                    }}

                                />
                            </Grid> */}
            </Grid>
          </Grid>
        );
      case 10:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginBottom: 160 }}
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.stewardess}
                  suggestions={this.state.stewardess}
                  placeholder="Selecione as comissárias"
                  label="Comissária(s) do Voo"
                  onChange={(value) => {
                    let { modal, stewardess_default } = this.state;
                    let { stewardess_reserve } = this.state.modal;
                    let no = [...value, ...stewardess_reserve];
                    let aux = [];
                    let list = stewardess_default;
                    no.map((e) => {
                      aux = list.filter((element) => element.value !== e.value);
                      list = list.filter(
                        (element) => element.value !== e.value
                      );
                    });
                    if (!no.length) aux = list;
                    this.setState({
                      modal: { ...modal, stewardess: value },
                      stewardess_reserve: aux,
                    });
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <MultiSelect
                                    isPax={{
                                        isPax: false,
                                        openPaxDialog: this.openPaxDialog
                                    }}
                                    value={this.state.modal.stewardess_reserve}
                                    suggestions={this.state.stewardess_reserve}
                                    placeholder='Selecione as comissárias'
                                    label='Comissária(s) Reserva(s) na Base'
                                    onChange={value => {
                                        let { modal, stewardess_default } = this.state;
                                        let { stewardess } = this.state.modal;
                                        let no = [...value, ...stewardess];
                                        let aux = [];
                                        let list = stewardess_default;
                                        no.map(e => {
                                            aux = list.filter(element => element.value !== e.value);
                                            list = list.filter(element => element.value !== e.value);
                                        })
                                        if (!no.length)
                                            aux = list;
                                        this.setState({ modal: { ...modal, stewardess_reserve: value }, stewardess: aux })
                                    }}
                                />
                            </Grid> */}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  id="catering"
                  label="Comissaria (Alimentos e Bebidas)"
                  placeholder="Comissaria (Alimentos e Bebidas) "
                  style={{ width: "100%", marginTop: 3 }}
                  value={this.state.modal.catering}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, catering: event.target.value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.supplier_stewarde}
                  suggestions={this.state.suppliers_stewarde}
                  placeholder="Selecione o fornecedor"
                  label="Fornecedor(es) da Comissaria"
                  onChange={(value) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, supplier_stewarde: value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    label="Observações"
                                    style={{ width: '100%' }}
                                    value={this.state.modal.obs_steward}
                                    onChange={event => {
                                        let { modal } = this.state;
                                        this.setState({ modal: { ...modal, obs_steward: event.target.value } })
                                    }}

                                />
                            </Grid> */}
            </Grid>
          </Grid>
        );
      case 10:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              spacing={8}
              style={{ marginBottom: 140 }}
            >
              <Grid container item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Typography
                  style={{ marginTop: 14, marginRight: 10 }}
                  variant="subheading"
                  id="modal-title"
                >
                  OK Para Voo:
                </Typography>
                <Switch
                  id="active"
                  checked={this.state.modal.status_maintenance}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        status_maintenance: event.target.checked,
                      },
                    });
                  }}
                  color="primary"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.mechanics}
                  suggestions={this.state.mechanics}
                  placeholder="Selecione os mecânicos"
                  label="Mecânico(s) Designado(s)"
                  // onChange={value => {
                  //     let { modal } = this.state;
                  //     this.setState({ modal: { ...modal, mechanics: value } })
                  // }}
                  onChange={(value) => {
                    let { modal, maintenance } = this.state;
                    let { auxiliarys } = this.state.modal;
                    let no = [...value, ...auxiliarys];
                    let aux = [];
                    let list = maintenance;
                    no.map((e) => {
                      aux = list.filter((element) => element.value !== e.value);
                      list = list.filter(
                        (element) => element.value !== e.value
                      );
                    });
                    if (!no.length) aux = list;
                    this.setState({
                      modal: { ...modal, mechanics: value },
                      auxiliarys: aux,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <MultiSelect
                  isPax={{
                    isPax: false,
                    openPaxDialog: this.openPaxDialog,
                  }}
                  value={this.state.modal.auxiliarys}
                  suggestions={this.state.auxiliarys}
                  placeholder="Selecione os auxiliares"
                  label="Auxiliar(es) Designado(s)"
                  // onChange={value => {
                  //     let { modal } = this.state;
                  //     this.setState({ modal: { ...modal, auxiliarys: value } })
                  // }}
                  onChange={(value) => {
                    let { modal, maintenance } = this.state;
                    let { mechanics } = this.state.modal;
                    let no = [...value, ...mechanics];
                    let aux = [];
                    let list = maintenance;
                    no.map((e) => {
                      aux = list.filter((element) => element.value !== e.value);
                      list = list.filter(
                        (element) => element.value !== e.value
                      );
                    });
                    if (!no.length) aux = list;
                    this.setState({
                      modal: { ...modal, auxiliarys: value },
                      mechanics: aux,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  label="Observações de manutenção"
                  style={{ width: "100%" }}
                  value={this.state.modal.obs_maintenance}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, obs_maintenance: event.target.value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      case 3:
        return (
          <Grid container spacing={8}>
            <Grid
              container
              alignItems="flex-end"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginBottom: 20 }}
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  label="Observações gerais"
                  style={{ width: "100%" }}
                  value={this.state.modal.obs_operation}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, obs_operation: event.target.value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  label="Observações de Fuso horário"
                  style={{ width: "100%" }}
                  value={this.state.modal.fuso_information}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, fuso_information: event.target.value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  onClick={() => {
                    this.props.handleSave({ ...this.state.modal });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Salvar
                </Button>
                <Button onClick={this.handleCloseStep} color="secondary">
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        );
      default:
        return "Etapa em desenvolvimento";
    }
  };

  handleNext = () => {
    if (this.state.activeStep < 7)
      this.setState({ activeStep: this.state.activeStep + 1 });
  };

  handleJump = (index) => {
    if (this.state.activeStep === index) this.setState({ activeStep: -1 });
    else this.setState({ activeStep: index });
  };

  handleBack = () => {
    if (this.state.activeStep > 0)
      this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleTime = async (value) => {
    if (value) {
      let time = new Date();
      time.setHours(value.split(":")[0]);
      time.setMinutes(value.split(":")[1]);
      return time;
    }
    return null;
  };

  _handleIdMultiSelect = async (value) => {
    if (value) {
      return await value.map((element) => ({
        value: element.id,
        label: element.first_name + " " + element.last_name,
      }));
    }
    return null;
  };

  _handleIdMultiSelectProviders = async (value) => {
    if (value) {
      return await value.map((element) => ({
        value: element.id,
        label: element.name + " - " + element.base,
      }));
    }
    return null;
  };

  handleCloseStep = () => {
    Swal.fire({
      title: "<strong>Deseja sair sem salvar a etapa?</strong>",
      type: "info",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then((result) => {
      if (!!result.value) {
        this.props.func();
      }
    });
  };

  onRender = async () => {
    if (this.props.modal.id === "new")
      this.setState({
        modal: {
          id: "new",
          from: this.props.preMission.to ? this.props.preMission.to : "",
          to: "",
          status: "Solicitado",
          date: this.props.preMission.arrival_date
            ? this.props.preMission.arrival_date
            : new Date(),
          local_time: "",
          passengers_summary: this.props.preMission.passengers_summary
            ? this.props.preMission.passengers_summary
            : "",
          observations: "",
          logbook_number: "",
          request_obs: "",
          origin: this.props.preMission.destination
            ? this.props.preMission.destination
            : "",
          destination: "",
          alternate_destination: "",
          departure_date: this.props.preMission.arrival_date
            ? this.props.preMission.arrival_date
            : new Date(),
          presentation_time: "",
          hangar_time_departure: "",
          takeoff_time: "",
          arrival_date: null,
          takeoff_time_utc: "",
          arrival_time: "",
          arrival_time_utc: "",
          flight_time: "",
          fuel: "",
          load: "",
          speed: "",
          qty_pax: "",
          passengers: [],
          coord_pilots: [],
          second_pilots: [],
          reserve_pilots: [],
          mechanics: [],
          auxiliarys: [],
          catering: "",
          stewardess: [],
          stewardess_reserve: [],
          supplier_origin: [],
          supplier_origin_service: [],
          supplier_fuel: [],
          supplier_destination: [],
          supplier_destination_service: [],
          supplier_hotel: [],
          supplier_stewarde: [],
        },
        activeStep: 0,
        title: "Nova",
      });
    else {
      let {
        passengers,
        coord_pilots,
        second_pilots,
        reserve_pilots,
        mechanics,
        auxiliarys,
        stewardess,
        stewardess_reserve,
        supplier_origin,
        supplier_origin_service,
        supplier_fuel,
        supplier_destination,
        supplier_destination_service,
        supplier_hotel,
        supplier_stewarde,
      } = this.props.modal;
      await this.setState({
        modal: {
          ...this.props.modal,

          passengers: await this._handleIdMultiSelect(passengers),
          coord_pilots: await this._handleIdMultiSelect(coord_pilots),
          second_pilots: await this._handleIdMultiSelect(second_pilots),
          reserve_pilots: await this._handleIdMultiSelect(reserve_pilots),
          mechanics: await this._handleIdMultiSelect(mechanics),
          auxiliarys: await this._handleIdMultiSelect(auxiliarys),
          stewardess: await this._handleIdMultiSelect(stewardess),
          stewardess_reserve: await this._handleIdMultiSelect(
            stewardess_reserve
          ),
          // suppliers: await this._handleIdMultiSelectProviders(suppliers),
          supplier_origin: await this._handleIdMultiSelectProviders(
            supplier_origin
          ),
          supplier_origin_service: await this._handleIdMultiSelectProviders(
            supplier_origin_service
          ),
          supplier_fuel: await this._handleIdMultiSelectProviders(
            supplier_fuel
          ),
          supplier_destination: await this._handleIdMultiSelectProviders(
            supplier_destination
          ),
          supplier_destination_service:
            await this._handleIdMultiSelectProviders(
              supplier_destination_service
            ),
          supplier_hotel: await this._handleIdMultiSelectProviders(
            supplier_hotel
          ),
          supplier_stewarde: await this._handleIdMultiSelectProviders(
            supplier_stewarde
          ),
        },
        activeStep: 0,
        title: "Editar",
      });
    }
  };

  createNewPax = (newPax) => {
    let { modal } = this.state;

    UserService.get(null, null, true, null, true).then(async (result) => {
      if (result.ok) {
        let suggestions = await result.response.map((element) => ({
          value: element.id,
          label: element.first_name + " " + element.last_name,
        }));

        modal.passengers.unshift({
          label: newPax.first_name + " " + newPax.last_name,
          value: newPax.id,
        });
        this.setState({
          users: suggestions,
          modal,
        });
      }
    });
  };

  permissionChangeStatus = () => {
    if (this.state.role == "Mecânico") return true;
    else if (
      this.state.role == "Diretor de Manutenção" &&
      this.state.modal.status == "Agendado"
    )
      return true;
    else if (this.state.role == "Auxiliar de Manutenção") return true;
    else if (this.state.role == "Comissárias") return true;
    else if (this.state.role == "Solicitante") return true;
    else if (this.state.role == "Consulta") return true;
    else if (this.state.role == "PAX") return true;

    if (
      this.state.role == "Coordenação" &&
      this.state.modal.status != "Agendado"
    )
      return true;

    return false;
  };

  render() {
    var steps = allowAccessToMissionRequestAdmin.includes(this.profile)
      ? [
          "Origem " + this.state.modal.from,
          "Destino " + this.state.modal.to,
          // "Alternativo",
          "Passageiros",
          // "Pilotos",
          // "Comissária",
          // "Detalhes de Manutenção",
          "Observações",
        ]
      : ["Passageiros"];
    return (
      <Dialog
        open={this.props.openModal}
        onEnter={this.onRender}
        maxWidth="md"
        style={styles.container}
        scroll="body"
      >
        <DialogTitle>
          {this.state.title + " Etapa"}
          <br />
          <span
            style={{
              fontSize: 12,
              fontFamily: "Roboto",
              color: colors.regular,
            }}
          >
            Campos Obrigatórios*
          </span>
        </DialogTitle>
        <DialogContent>
          <PassengersModal
            modal={this.state.modalPax}
            openModal={this.state.openPax}
            func={this.openPaxDialog}
            handleSave={this.handleSavePax}
          />
          <Grid item md={12}>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextField
                  id="from"
                  label="Origem"
                  style={{ width: "100%" }}
                  value={this.state.modal.from}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, from: event.target.value },
                    });
                    // this.setState({ modal: { ...modal, origin: event.target.value } })
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextField
                  id="to"
                  label="Destino"
                  style={{ width: "100%" }}
                  value={this.state.modal.to}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, to: event.target.value },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextField
                  id="status"
                  select
                  label="Status"
                  style={{ width: "100%", margin: 0 }}
                  value={this.state.modal.status}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, status: event.target.value },
                    });
                    this.setState({ isChanged: true });
                  }}
                  margin="normal"
                  disabled={this.permissionChangeStatus()}
                >
                  <MenuItem disabled>Selecione o status</MenuItem>
                  {(MissionStatusAuthorized.includes(this.state.modal.status) ||
                  StatusToConfirm.includes(this.state.modal.status)
                    ? MissionStatusAuthorized
                    : MissionStatusNotAuthorized
                  ).map((element) => (
                    <MenuItem key={element} value={element}>
                      {element}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                  locale="pt-br"
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    label="Data de Decolagem*"
                    format="DD/MM/YYYY"
                    disablePast
                    cancelLabel="SAIR"
                    okLabel="OK"
                    value={this.state.modal.date}
                    onChange={(date) => {
                      let { modal } = this.state;
                      this.setState({
                        modal: {
                          ...modal,
                          date: date,
                          departure_date: date,
                          arrival_date: date,
                        },
                      });
                    }}
                    animateYearScrolling
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField
                  id="time"
                  label="Hora de Decolagem(Local)"
                  type="time"
                  // defaultValue="00:00"
                  style={{ width: "100%" }}
                  value={this.state.modal.local_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        local_time: event.target.value,
                        takeoff_time: event.target.value,
                      },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
                {/* <MuiPickersUtilsProvider
                                    utils={MomentUtils}
                                    moment={moment}
                                    locale='pt-br'
                                >
                                    <TimePicker
                                        style={{ width: '100%' }}
                                        label="Hora de Decolagem(Local)"
                                        clearable
                                        ampm={false}
                                        clearLabel='LIMPAR'
                                        cancelLabel='SAIR'
                                        okLabel='OK'
                                        value={this.state.modal.local_time}
                                        onChange={local_time => {
                                            let { modal } = this.state;
                                            this.setState({ modal: { ...modal, local_time, takeoff_time: local_time } })
                                        }}
                                        animateYearScrolling
                                    />
                                </MuiPickersUtilsProvider> */}
              </Grid>

              <Grid item xs={12} sm={12} md={4}>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                  locale="pt-br"
                >
                  <DatePicker
                    style={{ width: "90%" }}
                    label="Data de Chegada"
                    format="DD/MM/YYYY"
                    clearable
                    clearLabel={"LIMPAR"}
                    cancelLabel="SAIR"
                    okLabel="OK"
                    minDate={this.state.modal.date}
                    value={this.state.modal.arrival_date}
                    onChange={(date) => {
                      let { modal } = this.state;
                      this.setState({
                        modal: { ...modal, arrival_date: date },
                      });
                    }}
                    animateYearScrolling
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <TextField
                  id="time"
                  label="Hora de Chegada(Local)"
                  type="time"
                  // defaultValue="00:00"
                  style={{ width: "100%" }}
                  value={this.state.modal.arrival_time}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, arrival_time: event.target.value },
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5 min
                  }}
                />
                {/* <MuiPickersUtilsProvider
                                    utils={MomentUtils}
                                    moment={moment}
                                    locale='pt-br'
                                >
                                    <TimePicker
                                        style={{ width: '100%' }}
                                        label="Hora de Decolagem(Local)"
                                        clearable
                                        ampm={false}
                                        clearLabel='LIMPAR'
                                        cancelLabel='SAIR'
                                        okLabel='OK'
                                        value={this.state.modal.local_time}
                                        onChange={local_time => {
                                            let { modal } = this.state;
                                            this.setState({ modal: { ...modal, local_time, takeoff_time: local_time } })
                                        }}
                                        animateYearScrolling
                                    />
                                </MuiPickersUtilsProvider> */}
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  id="passengers_summary"
                  label="Passageiros"
                  style={{ width: "100%" }}
                  value={this.state.modal.passengers_summary}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: {
                        ...modal,
                        passengers_summary: event.target.value,
                      },
                    });
                  }}
                />
              </Grid> */}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  id="request_obs"
                  label="Observações "
                  style={{ width: "100%" }}
                  value={this.state.modal.observations}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, observations: event.target.value },
                    });
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  id="logbook_number"
                  label="Número do diário de bordo"
                  style={{ width: "100%" }}
                  value={this.state.modal.logbook_number}
                  onChange={(event) => {
                    let { modal } = this.state;
                    this.setState({
                      modal: { ...modal, logbook_number: event.target.value },
                    });
                  }}
                />
              </Grid> */}
            </Grid>
            <Grid container style={{ marginTop: 10, marginBottom: 40 }}>
              <Button
                onClick={() => {
                  this.props.handleSave({ ...this.state.modal });
                }}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
              <Button onClick={this.handleCloseStep} color="secondary">
                Cancelar
              </Button>
            </Grid>
            <Stepper
              activeStep={this.state.activeStep}
              style={{ width: "100%", margin: 0, padding: 0, marginTop: 10 }}
              orientation="vertical"
            >
              {steps.map((label, index) => (
                <Step key={label} style={{ width: "100%", padding: 0 }}>
                  <StepLabel
                    onClick={(event) => this.handleJump(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography style={{ fontSize: 18 }}>{label}</Typography>
                  </StepLabel>
                  <StepContent style={{ margin: 0, marginLeft: 12 }}>
                    {this.getStepContent(index)}
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleBack} color="primary">
            Anterior
          </Button>
          <Button onClick={this.handleNext} color="primary">
            Próximo
          </Button>
          <Button
            onClick={() => {
              this.props.handleSave({ ...this.state.modal });
            }}
            variant="contained"
            color="primary"
          >
            Salvar
          </Button>
          <Button onClick={this.handleCloseStep} color="secondary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = {
  container: {
    overFlowY: "none",
  },
  modal: {
    padding: 10,
  },
};

// export default ModalMission;
const mapStateToProps = (state) => ({
  user: state.authReducer.user,
});

const mapDispatchToProps = {
  navigate,
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalMission);



// WEBPACK FOOTER //
// ./src/routes/missions/mission-admin/Modal.js